import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUsersTwo = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.93 14.875c-3.376 0-6.254.51-6.254 2.553s2.863 2.57 6.255 2.57c3.374 0 6.254-.51 6.254-2.552 0-2.043-2.862-2.571-6.254-2.571"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.91 14.473c1.421.211 2.413.71 2.413 1.736 0 .706-.467 1.165-1.221 1.45"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.926 7.995a3.995 3.995 0 1 1-7.99 0 3.995 3.995 0 0 1 7.99 0"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.975 10.948a3.02 3.02 0 0 0 2.598-2.988c0-1.48-1.07-2.742-2.53-2.983"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUsersTwo);
export default ForwardRef;
